import React from 'react';

/**
 * Lightweight loading page shown in the auth popup before redirecting to Google.
 * The parent window sets window.__AUTH_REDIRECT_URL on this popup to trigger the redirect.
 */
export default function AuthLoadingPage() {
  React.useEffect(() => {
    // Check if we were given a redirect URL via the opener
    const check = () => {
      try {
        if (window.__AUTH_REDIRECT_URL) {
          window.location.href = window.__AUTH_REDIRECT_URL;
          return;
        }
      } catch {}
      // Also check URL params as fallback
      const params = new URLSearchParams(window.location.search);
      const url = params.get('url');
      if (url) {
        window.location.href = url;
        return;
      }
      // Keep checking
      setTimeout(check, 100);
    };
    check();

    // Safety timeout — close if no redirect after 15s
    const timeout = setTimeout(() => {
      document.getElementById('status').textContent = 'Authentication timed out. Please close this window and try again.';
    }, 15000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p id="status" className="text-sm text-muted-foreground">Connecting to Google...</p>
      </div>
    </div>
  );
}
